import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AUTOMATION_USER, StorageKeys } from '@core/constants';
import { UserModel } from '@core/models/user-model';
import { FeatureFlagService } from '@core/services/feature-flag/feature-flag.service';
import { HotjarService } from '@core/services/hotjar/hotjar.service';
import { RolesService } from '@core/services/roles.service';
import { SessionStorageService } from '@core/services/session-storage/session-storage.service';
import { StorageService } from '@core/services/storage/storage.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';

import { LoadCountriesProps } from '../countries/countries.actions';
import { LoadStatesProps } from '../states/states.actions';
import { LoadTimezonesProps } from '../timezones/timezones.actions';
import { SetUserRolesAreReady } from '../user/user.actions';
import {
  GetUserProfile,
  LoadIsCollapsed,
} from '../userProfile/userProfile.actions';

import { Login, Logout } from './auth.actions';

@Injectable()
export class AuthEffects {
  rolesService = inject(RolesService);
  hotjarService = inject(HotjarService);
  featureFlagService = inject(FeatureFlagService);

  constructor(
    private actions$: Actions,
    private router: Router,
    private storageService: StorageService,
    private sessionStorageService: SessionStorageService,
    private store: Store
  ) {}

  login$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(Login),
        tap((action) => {
          this.storageService.save<UserModel>(
            action.user,
            StorageKeys.authUser
          );

          this.store.dispatch(GetUserProfile());
          this.store.dispatch(LoadCountriesProps());
          this.store.dispatch(LoadStatesProps());
          this.store.dispatch(LoadTimezonesProps());
          this.store.dispatch(LoadIsCollapsed());
          this.rolesService.loadPermissions();
          this.featureFlagService.updateContext();
          if (action.user.email !== AUTOMATION_USER) {
            this.hotjarService.initHotjar();
            this.hotjarService.identifyUser();
          }
        })
      );
    },
    { dispatch: false }
  );

  logout$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(Logout),
        tap(() => {
          this.storageService.delete(StorageKeys.authUser);
          this.sessionStorageService.delete(StorageKeys.centralCreateLabel);
          this.sessionStorageService.delete(StorageKeys.centralEditPickup);
          this.storageService.delete(StorageKeys.impersonation);
          this.storageService.delete(StorageKeys.userProfile);
          this.storageService.delete(StorageKeys.captchaResponse);
          this.router.navigateByUrl('/login');
          this.store.dispatch(SetUserRolesAreReady({ isReady: false }));
        })
      );
    },
    { dispatch: false }
  );
}
